<template>
	<b-modal v-model="mostrar_agregar_glosa" ref="modalAgregarGlosa" size="xl" centered header-bg-variant="dark" header-text-variant="light">
		<template #modal-header=""><h5>AGREGAR GLOSA Y REFERENCIAS</h5></template>
		<template #default="">
			<b-form id="agregarGlosaForm">
				<div class="row">
					<div class="col-6">Facturar a:</div>
					<div class="col-6">Fecha de Emisión</div>
				</div>
				<div class="row">
					<div class="col-6"><hr style="margin-top: 5px; margin-right: 15px" /></div>
					<div class="col-6"><hr style="margin-top: 5px" /></div>
				</div>
				<div class="row">
					<div class="col-6">
						<div class="row">
							<div class="col-12">
								<div class="info">
									<div>{{ cliente._source.CLIENT_NAME }}</div>
									<div>R.U.T.: {{ cliente._source.CLIENT_TAX_CODE }}</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<b-badge variant="info">OC: {{ cliente._source.ORDEN_COMPRA }}</b-badge>&nbsp;
								<b-badge variant="info">DESGLOSE: {{ cliente._source.DESGLOSE }}</b-badge>&nbsp;
								<b-badge variant="info">HES: {{ cliente._source.HES }}</b-badge>&nbsp;
								<b-badge variant="info">C.C.: {{ cliente._source.CENTRO_COSTO }}</b-badge>
							</div>
						</div>
					</div>
					<div class="col-4">
						<div class="row">
							<div class="col-12">
								<b-input-group size="sm" prepend="Fecha de Emisión">
									<date-picker id="fecha_emision" name="fecha_emision" :value="getFechaEmision"
										:config="{ format: 'DD/MM/YYYY', locale: 'es' }" placeholder="Ingresar Fecha" required>
									</date-picker>
								</b-input-group>
							</div>
						</div>
						<p></p>
						<div class="row">
							<div class="col-12">
								<b-form-checkbox id="con_iva" name="con_iva" switch :checked="getConIVA">Con I.V.A.</b-form-checkbox>
							</div>
						</div>
					</div>
				</div>
				<p></p>
				<div class="row">
					<div class="col-12">
						<a class="btn-success plus" @click="agregarFila(1)"><i class="fas fa-plus fa-fw" /></a>
						<a class="btn-danger minus" @click="eliminarFila(1)"><i class="fas fa-minus fa-fw" /></a>
					</div>
				</div>
				<div class="row">
					<div class="col-12"><hr style="margin-top: 8px" /></div>
				</div>
				<div class="row">
					<div class="col-md-12" id="referencias">
						<referencia v-if="factura.referencias == undefined" @evento-objeto-id="onObjetoIdEvent"></referencia>
						<referencia v-else v-for="(referencia, index) in getReferencias" :key="index" :referencia="referencia" @evento-objeto-id="onObjetoIdEvent"></referencia>
					</div>
				</div>
				<p></p>
				<div class="row">
					<div class="col-12">
						<a class="btn-success plus" @click="agregarFila(2)"><i class="fas fa-plus fa-fw" /></a>
						<a class="btn-danger minus" @click="eliminarFila(2)"><i class="fas fa-minus fa-fw" /></a>
					</div>
				</div>
				<div class="row">
					<div class="col-12"><hr style="margin-top: 8px" /></div>
				</div>
				<div class="row">
					<div class="col-md-12" id="glosas">
						<glosa v-if="factura.glosas == undefined" @evento-objeto-id="onObjetoIdEvent"></glosa>
						<glosa v-else v-for="(glosa, index) in getGlosas" :key="index" :glosa="glosa" @evento-objeto-id="onObjetoIdEvent"></glosa>
					</div>
				</div>
			</b-form>
		</template>
		<template #modal-footer="">
			<b-button size="sm" variant="success" @click="agregarGlosa">Agregar</b-button>
			<b-button size="sm" variant="secondary" @click="cerrarAgregarGlosa">Cerrar</b-button>
		</template>
	</b-modal>
</template>
<script lang="ts">

	import Vue from "vue"
	import { uuid } from "vue-uuid"
	import $ from "jquery"
	import moment from "moment"
	import Referencia from "./referencia.vue"
	import Glosa from "./glosa.vue"


	export default {
		name: "AgregarGlosa",
		components: { Referencia, Glosa },
		props: {
			cliente: Object, // Objeto que tiene los datos del cliente
			id: String, // Identificador para relacionar la info ingresada con el total de la facturacion
			factura: Object, // Objeto que tiene la información de la factura
			onCerrar: Function, // Funcion callback para cuando se cierre la ventana
			onAgregar: Function, // Funcion callback para cuando se agregue una glosa
		},
		data() {
			return {
				mostrar_agregar_glosa: true, // Flag que controla el despliegue de la ventana
				fecha_emision: "", // Campo que guarda el valor de la fecha de emisión seleccionada para pasara al objeto "Fecha Emision"
				con_iva: false, // Propiedad que guarda la seleccion del flag "Con I.V.A."
				referencias: [], // Arreglo con el ID de las referencias agregadas por el usuario para poder eliminarlas cuando corresponda
				glosas: [], // Arreglo con el ID de las glosas agregadas por el usuario para poder eliminarlas cuando corresponda
				tfactura: this.factura,
			}
		},
		computed: {

			// Devuelve un guid para los componentes referencia y glosa
			getId() {

				return uuid.v1()
			},

			// Devuelve la fecha de emision de la factura
			getFechaEmision() {

				var value = ""
				if (this.factura.fecha_emision != undefined)
					value = moment.unix(this.factura.fecha_emision).format("DD/MM/YYYY")

				return value 
			},

			getConIVA() {

				var value = false 
				if (this.factura.iva != undefined)
					value = this.factura.iva

				return value
			},

			// Devuelve un arreglo con las referencias que tenga la factura
			getReferencias() {

				return this.factura.referencias
			},

			// Devuelve un arreglo con las glosas que tenga la factura
			getGlosas() {

				return this.factura.glosas
			}
        },
		methods: {

			// Accion que agrega en la pantalla otra fila para ingresar Referencias (Nº, Fecha, Comentario) o Glosas (Referencia, Glosa, Monto)
			// Al agregar una nueva fila, el componente creado nos informa el ID unico mediante el evento "evento-objeto-id"
			// Guardamos el ID en la lista que le corresponda para poder eliminarlo al presionar el boton "-" correspondiente
			agregarFila(tipo) {

				var component = null
				var destino = ""

				// Se agrego una fila de Referencias
				if (tipo == 1)
				{
					component = Vue.extend(Referencia)
					destino = "#referencias"
				}

				// Se agrego una fila de Glosas
				if (tipo == 2)
				{
					component = Vue.extend(Glosa)
					destino = "#glosas"
				}

				var o = new component()
				// Funcion Callback que se llamara cuando el componente nos informe el ID unico asociado
				o.$on("evento-objeto-id", this.onObjetoIdEvent)
				o.$mount()
				$(destino).append(o.$el)
			},

			// Para eliminar una fila desde el formulario
			eliminarFila(tipo) {

				// Eliminamos la ultima fila agregada a las referencias
				if (tipo == 1)
				{
					// Si hay elementos para eliminar, seguimos
					if (this.referencias.length > 1)
					{
						var cid = this.referencias.pop() // Obtenemos el ID de la ultima fila agregada y lo sacamos de la lista
						$("#" + cid).remove() // Eliminamos el objeto del DOM
					}
				}

				// Eliminamos la ultima fila agregada a las Glosas
				if (tipo == 2)
				{
					// Si hay elementos para eliminar, seguimos
					if (this.glosas.length > 1)
					{
						var cid = this.glosas.pop() // Obtenemos el ID de la ultima fila agregada y lo sacamos de la lista
						$("#" + cid).remove() // Eliminamos el objeto del DOM
					}
				}
			},

			// Click en el boton "Agregar"
			agregarGlosa() {

				// Guardamos los datos del formulario para validacion
				var form = $("#agregarGlosaForm")[0]
				var data = new FormData(form)

				// Flag que controla si se cierra la ventana cuando todos los campos tengan valor o sigue activa indicando lo que falta
				var seguir = false 

				// Recorremos todos los campos del formulario para validar que tengan datos
				// Si hay uno que no tenga dato, lo destacamos con un borde rojo (clase is-invalid)
				data.forEach(function(value, key, o) {

					var required = $("#" + key).attr("required")
					if (required != undefined && value == "") {

						$("#" + key).addClass("is-invalid")
						seguir = true
					} else
						$("#" + key).removeClass("is-invalid")
				})

				$(".referencia").each(function(index) {

					var codeSii = $(this).find(".referencia-refe").val();
					var numero = $(this).find(".referencia-numero").val();
					var fecha = $(this).find(".referencia-fecha").val();

					if (codeSii != "")
					{
						if (numero == "") {

							$(this).find(".referencia-numero").addClass("is-invalid")
							seguir = true
						} else
							$(this).find(".referencia-numero").removeClass("is-invalid")

						if (fecha == "") {

							$(this).find(".referencia-fecha").addClass("is-invalid")
							seguir = true
						} else
							$(this).find(".referencia-fecha").removeClass("is-invalid")
					}
				})

				// Si hay campos sin valor, no se cierra la ventana
				if (seguir)
					return

				// Llegamos aqui porque todos los campos del formulario tienen valor (validacion exitosa)
				// Recorremos todos los campos del formulario y la data la guardamos en un objeto que enviaremos al padre para guardarlo en la lista de facturas

				// Recorremos las referencias
				var referencias = []
				$(".referencia").each(function(index) {

					var codeSii = $(this).find(".referencia-refe").val();
					if (codeSii != "")
					{
						// Parseamos la fecha para transformarla al formato YYYY-MM-DD
						var fecha = $(this).find(".referencia-fecha").val()
						var tmp = fecha.split("/")
						var fFecha = tmp[2] + "-" + tmp[1] + "-" + tmp[0]

						referencias.push({ 
							"codeSii": codeSii,
							"referenceDate": moment(fFecha).format("X"),
							"number": $(this).find(".referencia-numero").val(),
							"reason": $(this).find(".referencia-comentario").val()
						})
					}
				})

				// Recorremos las glosas
				// Aprovechamos de sumar el total de la factura
				var glosas = []
				var total_factura = 0
				$(".glosa").each(function(index) {

					glosas.push({
						"comment": $(this).find(".glosa-glosa").val(),
						"netUnitValue": parseInt($(this).find(".glosa-monto").val()),
						"quantity": 1
					})

					// Sumamos todos los montos ingresados en cada glosa, para mostrarlos en el campo Monto asociado al cliente (en la ventana de refacturacion)
					total_factura += parseInt($(this).find(".glosa-monto").val())
				})

				// Mostramos el total de la factura en la ventana de refacturacion
				$("#monto_" + this.id).val(total_factura)

				// Parseamos la fecha para transformarla al formato YYYY-MM-DD
				var fecha = $("#fecha_emision").val()
				var tmp = fecha.split("/")
				var fFecha = tmp[2] + "-" + tmp[1] + "-" + tmp[0]

				// Flag que controla si la factura es con IVA o no
				var con_iva = $("#con_iva").is(":checked")

				// Objeto donde se guardaran todos los datos para enviarlo a la ventana refacturacion 
				this.tfactura = {
					cid: this.id, // ID que permite relacionar la factura con el campo Monto y el boton Agregar de la ventana de refacturacion
					_id: this.cliente._id,
					total_fac: total_factura,
					glosas: glosas,
					referencias: referencias,
					fecha_emision: moment(fFecha).format("X"),
					iva: con_iva
				}	

				// Cerramos la ventana
				this.mostrar_agregar_glosa = seguir

				// Llamamos a la funcion callback asociada a la accion de agregar una glosa
				if (this.onAgregar)
					this.onAgregar(this.tfactura)
			},

			// Si se cierra la ventana Agregar Glosa, se cambia el valor del flag que controla si se muestra o no
			// FALSE: no se muestra - TRUE: se muestra
			cerrarAgregarGlosa() {

				this.mostrar_agregar_glosa = false

				// Llamamos a la funcion callback asociada a la accion de cerrar la ventana 
				if (this.onCerrar)
					this.onCerrar(this.mostrar_agregar_glosa)
			},

			// Guardamos el ID en la lista de referencias o lista de glosas agregadas por el usuario, para poder eliminarlas al presionar el boton "-"
			// Se elimina desde la ultima a la primera agregada
			onObjetoIdEvent(data) {

				if (data.tipo == 1) // Es una referencia
					this.referencias.push(data.id)
				else if (data.tipo == 2) // Es una glosa
					this.glosas.push(data.id)
			},
		}
	}
</script>
<style scoped>

	.plus {
		padding: 3px 5px 3px 5px;
		border-top-left-radius: 3px;
		border-bottom-left-radius: 3px; 
	}

	.minus {
		padding: 3px 5px 3px 5px;
		border-top-right-radius: 3px;
		border-bottom-right-radius: 3px; 
	}
</style>
